import { UpdateMembershipRolesInput } from "@supernova-studio/model";
import { z } from "zod";
import { DTOWorkspaceInvitationsListInput, DTOWorkspaceMembersListResponse, DTOWorkspaceResponse } from "../../dto";
import { RequestExecutor } from "../../transport";

export class WorkspaceMembersEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/members`, DTOWorkspaceMembersListResponse, {
      method: "GET",
    });
  }

  update(workspaceId: string, body: UpdateMembershipRolesInput) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/members/role`, DTOWorkspaceResponse, {
      method: "PUT",
      body,
    });
  }

  invite(workspaceId: string, body: DTOWorkspaceInvitationsListInput) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/members`, z.any(), { method: "POST", body });
  }

  delete(workspaceId: string, userId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/members/${userId}`, DTOWorkspaceResponse, {
      method: "DELETE",
    });
  }
}
